export const mapDbTypeToUi = (t) => {
  const k = String(t || '').toLowerCase();
  if (k.startsWith('data')) return 'data';
  if (k.startsWith('hybrid')) return 'hybrid';
  return 'time';
};
export const toKbps = (mbps) => (mbps ? (Number(mbps) || 0) * 1000 : '');
export const mapPlanToForm = (p) => ({
  name: p.name || p.plan_name || '',
  type: p.type || mapDbTypeToUi(p.plan_type),
  durationMinutes: p.durationMinutes ?? p.duration_minutes ?? '',
  quotaMB: p.quotaMB ?? p.data_limit_mb ?? '',
  price: p.price ?? '',
  currency: p.currency || 'UGX',
  speedKbps: (p.speedKbps ?? (p.download_mbps != null ? toKbps(p.download_mbps) : null)) ?? '',
  maxDevices: p.maxDevices ?? p.concurrent_sessions ?? p.shared_users ?? 1,
  portalVisible: typeof p.portalVisible === 'boolean' ? p.portalVisible : (p.is_visible ?? 1) === 1,
  expiresAfterHours: p.expiresAfterHours ?? p.voucher_expiry_hours ?? 24,
  description: p.description ?? p.notes ?? '',
  active: typeof p.active === 'boolean' ? p.active : (p.status || 'active') === 'active',
  sort: p.sort ?? p.sort_order ?? 0,
});
export const payloadToRow = (payload, fallbackId) => {
  const a = payload.attrs || {};
  return {
    id: fallbackId,
    name: payload.plan_name,
    type: mapDbTypeToUi(a.plan_type),
    durationMinutes: a.duration_minutes ?? null,
    quotaMB: a.data_limit_mb ?? null,
    price: payload.price || 0,
    currency: a.currency || 'UGX',
    speedKbps: a.download_mbps ? toKbps(a.download_mbps) : null,
    maxDevices: a.concurrent_sessions ?? a.shared_users ?? 1,
    portalVisible: (a.is_visible ?? 1) === 1,
    expiresAfterHours: a.voucher_expiry_hours ?? 24,
    description: payload.description || '',
    active: (a.status || 'active') === 'active',
    sort: a.sort_order ?? 0,
  };
};
